import { PAYMENT_RUN_STATUS } from './constants';

export function normalizeStatus(status: string | undefined): string {
  return (status ?? '').toLowerCase();
}

/** Display status Failed or Charge Failed (invoice payment failed). */
export function isPaymentRunFailedTabStatus(status: string | undefined): boolean {
  const s = normalizeStatus(status);
  return (
    s === PAYMENT_RUN_STATUS.FAILED || s === PAYMENT_RUN_STATUS.CHARGE_FAILED
  );
}

/** Card Charged or ACH Charged (captured payment in this run). */
export function isPaymentRunSuccessfulChargeTabStatus(
  status: string | undefined,
): boolean {
  const s = normalizeStatus(status);
  return (
    s === PAYMENT_RUN_STATUS.CARD_CHARGED ||
    s === PAYMENT_RUN_STATUS.ACH_CHARGED
  );
}

export function isReportRowStatusReady(status: string | undefined): boolean {
  return normalizeStatus(status?.trim()) === PAYMENT_RUN_STATUS.READY;
}

export function paymentRunRowBackgroundClass(status: string): string {
  const s = normalizeStatus(status);
  if (s === PAYMENT_RUN_STATUS.DROPPED || s === PAYMENT_RUN_STATUS.DUPLICATE) {
    return 'bg-red-50 dark:bg-red-950/25';
  }
  if (
    s === PAYMENT_RUN_STATUS.FEE_CAP ||
    s === PAYMENT_RUN_STATUS.CARD_CHARGED ||
    s === PAYMENT_RUN_STATUS.ACH_CHARGED
  ) {
    return 'bg-yellow-50/35 dark:bg-amber-950/10';
  }
  return '';
}
